import { useEffect, useState } from 'react';
import { fetchData, textWithColor,textWithIcon } from './Helpers';

export default function Funds() {
  const [fullData, setFullData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(fullData.filter(item => item.field.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Ownership_Funds").then((res) => {
      setFullData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'FIELD', field: 'field', scalable: true, leftPinned: true, binding: textWithColor },
      { name: '/VIEWS/FUND/BREAKDOWN', field: 'fundBreakdown', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/CONCENTRATION', field: 'fundConcentration', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/INVESTORS', field: 'fundInvestors', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/RECENT-ACTIVITY', field: 'fundRecentActivity', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/SHAREHOLDERS-HISTORY-REPORT', field: 'fundHistoryReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/SHAREHOLDERS-REPORT', field: 'fundReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/FUND/TOP-N-CONCENTRATION', field: 'fundTopConcentration', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INSIDER/SHAREHOLDERS-REPORT', field: 'insiderReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INSIDER/TRANSACTION-REPORT', field: 'insiderTrasactionReport', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/INVESTOR/HOLDINGS', field: 'insiderHoldings', scalable: true, binding: textWithIcon },
      { name: '/VIEWS/ULTIMATEPARENT/SHAREHOLDERS-REPORT', field: 'ultimateParentReport', scalable: true, binding: textWithIcon }
    ];

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([250, 200, 210, 200, 230, 330, 280, 280, 280, 280, 220, 350], false);
    }

    grid.config = {
      rowHeight: 120,
      headerRowHeight: 60,
      autoHideScrollbar: false,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : fullData
      }
    };
    grid.addEventListener("configured", gridConfigured);

  }, [fullData, searchData]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>

      <div id='loadingMask_div'>
        <h4>Funds</h4>
        <p>Available fields for Funds provided in the different Ownership end-points.</p>
        <ef-layout flex style={{ marginTop: '20px' }}>
          <ef-layout>
            <input
              className='search-field'
              type="text"
              placeholder="Type to search..."
              onChange={(e) => searchEvent(e.target.value)}
            />
          </ef-layout>
        </ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </div>

    </div>
  );
}